import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";

export default class FormListItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let self = this;
        let vm = this.props.vm; 
        let showOnFirstPage = this.props.noLabel;
        let titleNameUrl = context.root() + '/app/add-form/' + vm.id;

        if (vm.showOnFirstPage) {
            showOnFirstPage = this.props.yesLabel;
        }

        return (
            <tr>
                <td>
                    <a href={titleNameUrl}>{vm.id}</a>
                </td>
                <td>
                    <a href={titleNameUrl}>{vm.title}</a>
                </td>
                <td>{vm.formType}</td>
                <td>{showOnFirstPage}</td>
                <td>{vm.formattedCreationDate}</td>
                <td>{vm.creationOperator}</td>
                <td>{vm.formattedModifyDate}</td>
                <td>{vm.modifyOperator}</td>
            </tr>
        );
    }
}